import React from 'react';
import { useAppStore } from 'src/context/AppContext';
import OdfjellPanel, { PANEL_CONSTANTS } from '../ui/odfjellPanel/OdfjellPanel';

const AppModalComponent: React.FC = () => {
    const { appModalData, setAppModalData } = useAppStore();

    const action = () => {
        appModalData.action();
        setAppModalData(null);
    };

    const cancel = () => {
        appModalData.cancel();
        setAppModalData(null);
    };

    if (!appModalData) return <></>;

    /**
     * Renders message text with proper line breaks when \n is present
     */
    const renderMessage = (message: string | React.ReactNode) => {
        if (!message) return null;

        // If message is not a string, return it as is
        if (typeof message !== 'string') return message;

        return message.split('\n').map((text, index) => (
            <React.Fragment key={index}>
                {text}
                {index < message.split('\n').length - 1 && <br />}
            </React.Fragment>
        ));
    };

    return (
        appModalData && (
            <OdfjellPanel
                headerTitle={appModalData.title}
                defaultPosition="center"
                preventOutsideClose={true}
                hasCurtain={true}
                panelWidth={PANEL_CONSTANTS.MEDIUM_WIDTH}
                onAction={appModalData.action ? () => action() : null}
                actionButtonText={appModalData.actionButtonText}
                cancelButtonText={appModalData.cancelButtonText}
                onCancel={appModalData.cancel ? () => cancel() : null}
                showCancelButton={appModalData.cancel ? true : false}
                isCloseDisabled={appModalData.isCloseDisabled}
            >
                {renderMessage(appModalData.message)}
            </OdfjellPanel>
        )
    );
};

export default AppModalComponent;
